import script from "./Wall5View.vue?vue&type=script&setup=true&lang=js"
export * from "./Wall5View.vue?vue&type=script&setup=true&lang=js"

import "./Wall5View.vue?vue&type=style&index=0&id=ec3f38c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec3f38c8"]])

export default __exports__